export default {"src":"/_next/static/media/ic_social_chat.05f7854a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};